"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberHeader = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const MemberHeaderStyled = styled_components_1.default.div `
	&.header {
		display: flex;
		flex-direction: ${props => (props.$isMobile ? 'column' : 'row')};
		align-items: ${props => (props.$isMobile ? 'flex-start' : 'center')};
		justify-content: space-between;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		gap: ${props => (props.$isMobile ? '12px' : '0')};

		.active-bar {
			display: flex;
			flex-direction: row;
			gap: 12px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}

		.member {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h5-font-size, 16px);
			line-height: var(--h5-line-height, 24px);
			font-weight: var(--h5-font-weight, 700);
			position: relative;
			width: 128px;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}
`;
exports.MemberHeader = react_1.default.memo(({ handlerFilterList, isDetail, totalTableList = 0, }) => {
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(MemberHeaderStyled, { className: "header", "$isMobile": isMobile },
        react_1.default.createElement("div", { className: "member" }, t('conference.memberCount', {
            count: totalTableList,
        })),
        !isDetail && (react_1.default.createElement("div", { className: "active-bar", style: { gap: 14, height: '36px' } },
            react_1.default.createElement(common_1.SearchBar, { className: `search-bar-${isMobile ? 'mobile' : isTablet ? 'tablet' : 'big'}`, filterData: "nickname_like", handlerFilterList: handlerFilterList })))));
});
